import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Modal } from "components/designV2/modal/modal";
import { SearchableDropdown } from "components/designV2/searchableDropdown/searchableDropdown";
import type { SearchableDropdownOption } from "components/designV2/searchableDropdown/searchableDropdown.types";
import { useTranslation } from "react-i18next";
import { TeamFieldWrap, TeamModalError } from "./profilePanel.teamModal.styled";

interface ProfilePanelTeamModalProps {
  isOpen: boolean;
  isSaving: boolean;
  errorMessage: string;
  selectedTeamIds: string[];
  teamOptions: SearchableDropdownOption[];
  onSelectedValuesChange: (teamIds: string[]) => void;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Handles profile panel team modal.
 */
export const ProfilePanelTeamModal = (
  props: ProfilePanelTeamModalProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      label={t("Staff.ProfilePanelChangeTeam")}
      size="compact"
      allowContentOverflow
      footer={
        <>
          <SecondaryButton
            label={t("General.Cancel")}
            disabled={props.isSaving}
            onClick={props.onClose}
          />
          <PrimaryButton
            label={t("General.Ok")}
            isLoading={props.isSaving}
            onClick={props.onConfirm}
            disabled={props.selectedTeamIds.length === 0 || props.isSaving}
          />
        </>
      }
    >
      <TeamFieldWrap>
        <SearchableDropdown
          fullWidth
          label={`${t("Staff.AddStaffPanelFieldTeam")} (${t("Staff.AddStaffPanelMandatory")})`}
          options={props.teamOptions}
          selectedValues={props.selectedTeamIds}
          multiSelect
          onSelectedValuesChange={props.onSelectedValuesChange}
          placeholder={t("Staff.AddStaffPanelPlaceholderNotAssigned")}
        />
        {props.errorMessage.length > 0 && (
          <TeamModalError>{props.errorMessage}</TeamModalError>
        )}
      </TeamFieldWrap>
    </Modal>
  );
};
